export const SpotListState = {
    OPEN:"OPEN",
    CLOSED:"CLOSED",
    MINIMIZED:"MINIMIZED",
};